import urlJoin from 'url-join'

import { env } from '@/shared/config'

export function getAssetUrl(filename: string): string {
    const contentHash = env.CONTENT_HASH
    if (!(contentHash instanceof Object)) {
        throw new Error(`CONTENT_HASH must be an object, got: ${typeof contentHash}`)
    }

    const md5 = contentHash[filename]
    if (!md5) {
        throw new Error(`missing content hash for "${filename}"`)
    }

    return `${urlJoin(env.ASSET_PREFIX, filename)}?hash=${md5}`
}
